import type { HTMLAttributes, ReactNode } from "react";
import "./common.css";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  flush?: boolean;
  children: ReactNode;
}

export function Card({ flush = false, className = "", children, ...rest }: CardProps) {
  return (
    <div className={`card ${flush ? "card--flush" : ""} ${className}`} {...rest}>
      {children}
    </div>
  );
}
